<template>
  <div class="content">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="content-body two-columns table-wrapper">
      <div class="left">
        <div class="block">
           <PartForm ref="partForm" @on-saved="handleSaved" is-new></PartForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PartForm from './components/forms/part-form'
export default {
  name: 'PartNew',
  components: {
    PartForm
  },
  computed: {
    pageTitle: function () {
      document.title = this.$t('menu.part.new.title')
      return document.title
    }
  },
  methods: {
    handleSaved (resp) {
      this.$router.push({ name: 'menu.electronic_part.edit', params: { 'partId': resp.id } })
    }
  }
}
</script>
